import React, { Component } from 'react';

import LambdaUtil, { temporary_unitOfMeasureToReportUnits } from 'APP_ROOT/components/aws/lambda/lambdaUtil';
import { strings } from 'APP_ROOT/localization';

import DriverList from './DriverList';

import { fetchDemoCardTripReport } from '../demoApi';

export default class TripReportSection extends Component {

    constructor(props) {
        super(props);
        this.state = {
            tripReportHtml: null,
            tripRequestInProgress: true
        };
    }

    componentDidMount() {
        this.fetchTripReport();
    }

    fetchTripReport = () => {
        this.setState({
            tripReportHtml: null,
            tripRequestInProgress: true
        });

        const demo = this.props.user.original['custom:demo'];
        if(demo) {
            fetchDemoCardTripReport(demo, this.props.raven.ravenUuid, this.props.card.cardId).then(tripReport => {
                this.setTripReportHtml(tripReport.html)
            }).catch(err => {
                console.error('Failed to fetch trip report', err);
                this.setState({
                    tripReportHtml: null,
                    tripRequestInProgress: false
                });
            });
            return;
        }

        LambdaUtil.getTripReport(
            this.props.user.stage,
            this.props.raven.ravenUuid,
            this.props.card.cardId,
            temporary_unitOfMeasureToReportUnits(this.props.unitOfMeasure),
            this.onGetTripReportSuccess,
            this.onGetTripReportFail
        );
    }

    setTripReportHtml = html => {
        let wrapper = document.createElement('div');
        wrapper.innerHTML = html;

        var domElement = wrapper.querySelector('.report-section:nth-child(2)');
        if(domElement && domElement.innerHTML) {
            this.setState({
                tripReportHtml: { __html: domElement.innerHTML },
                tripRequestInProgress: false
            });
        } else {
            console.error('TripReportSection: dom query failed');
            this.setState({
                tripReportHtml: null,
                tripRequestInProgress: false
            });
        }
    }

    onGetTripReportSuccess = (data) => {

        var rawTrip = JSON.parse(data.Payload).tripReport;

        if (!rawTrip) {
            console.error("TripReportSection failed to load report for raven " + this.props.raven.ravenUuid + " card id " + this.props.card.cardId);
            this.setState({
                tripReportHtml: null,
                tripRequestInProgress: false
            });
            return;
        }

        this.setTripReportHtml(rawTrip.html);
    }

    onGetTripReportFail = (err) => {
        console.error(err);
        this.setState({
            tripReportHtml: null,
            tripRequestInProgress: false
        });
    }

    render() {

        const { features, card } = this.props;

        if (!this.state.tripReportHtml) {
            if (this.state.tripRequestInProgress) {
                return (
                    <div className="col-12 info-panel" id={this.props.id}>
                        <div className="row section-wrapper">
                            <div className="col-12 section-header">
                                <div className="trip-report-inner-html">{strings.loading}</div>
                            </div>
                        </div>
                    </div>
                );
            }
            return (
                <div className="col-12 info-panel" id={this.props.id}>
                    <div className="row section-wrapper">
                        <div className="col-12 section-header">
                            <div className="trip-report-inner-html">{strings.trip_report_failed}</div>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="col-12 info-panel" id={this.props.id}>
                <div className="row section-wrapper">
                    <div className="col-12 section-body">
                        <div className="row">
                            {features.facial_recognition &&
                                <DriverList
                                    drivers={card.drivers}
                                    stage={this.props.user.stage}
                                    assignDriver={this.props.assignDriver}
                                    setDriverName={this.props.setDriverName}
                                    allowEdit={this.props.raven.view === 'FLEET_ADMIN'}
                                />
                            }
                            <div className="trip-info trip-report-inner-html" dangerouslySetInnerHTML={this.state.tripReportHtml}></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
